import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from 'components/system/Paper';
import { ContentLoading } from 'components/system/Loading';
import AuthForm from 'components/pages/Auth/AuthForm';
import { auth, useAuthState } from 'api/services/firebase';
import bubbleCube from 'assets/images/bubbleCube.png';
import Logo from 'assets/svgIcons/logo.svg';
import jobScreenshot from 'assets/images/jobScreenshot.png';
import withSeo from 'components/hoc/withSeo';
import LandingAuthStyles from 'components/pages/LandingAuth/LandingAuth.styles';
import useQueryParams from 'hooks/useGetSearchParam';

const ensureValidUrl = (url) => {
  try {
    const parsedUrl = new URL(url, window.location.origin);
    return parsedUrl.searchParams.has('join'); // Ensure `join` is in query params
  } catch (error) {
    return false;
  }
};
const LandingAuth = ({ view = 'signUp', isMobile }) => {
  const [user, loading] = useAuthState(auth);
  const { useGetSearchParam } = useQueryParams();
  const navigate = useNavigate();

  const backUrl = useGetSearchParam('back');
  const validBackUrl = backUrl && ensureValidUrl(backUrl) ? backUrl : '/';

  useEffect(() => {
    if (user) {
      navigate(validBackUrl, { replace: true });
    }
  }, [user, validBackUrl, navigate]);

  if (loading) {
    return (
      <Box sx={LandingAuthStyles.page}>
        <ContentLoading />
      </Box>
    );
  }

  return (
    <Box sx={LandingAuthStyles.page}>
      <Box sx={LandingAuthStyles.header}>
        <Logo sx={{ height: '40px' }} />
      </Box>
      <Box sx={LandingAuthStyles.content}>
        <Box sx={LandingAuthStyles.container}>
          <Box sx={LandingAuthStyles.advert}>
            <Box sx={LandingAuthStyles.advertSlogans}>
              <Typography variant="h2" sx={LandingAuthStyles.advertTitle}>
                The simplest way to run quantum
              </Typography>
              <Box sx={LandingAuthStyles.sloganContainer}>
                <Box
                  sx={LandingAuthStyles.sloganIcon}
                  component="img"
                  src={bubbleCube}
                  alt="Benefits list icon"
                />
                <Typography variant="body1" sx={LandingAuthStyles.slogan}>
                  Fastest Simulators and QPUs
                </Typography>
              </Box>
              <Box sx={LandingAuthStyles.sloganContainer}>
                <Box
                  sx={LandingAuthStyles.sloganIcon}
                  component="img"
                  src={bubbleCube}
                  alt="Benefits list icon"
                />
                <Typography variant="body1" sx={LandingAuthStyles.slogan}>
                  Supports Cirq and Qiskit
                </Typography>
              </Box>
              <Box sx={LandingAuthStyles.sloganContainer}>
                <Box
                  sx={LandingAuthStyles.sloganIcon}
                  component="img"
                  src={bubbleCube}
                  alt="Benefits list icon"
                />
                <Typography variant="body1" sx={LandingAuthStyles.slogan}>
                  Simulate up to 40 qubits with 3 lines of code
                </Typography>
              </Box>
            </Box>
            <Box
              sx={LandingAuthStyles.advertJobScreenshot}
              component="img"
              src={jobScreenshot}
              alt="screenshot"
            />
          </Box>
          <Paper sx={LandingAuthStyles.authContainer}>
            <AuthForm view={view} backUrl={validBackUrl} isMobile={isMobile} />
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default withSeo(LandingAuth);
